"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var data_1 = require("../data");
/**
 * Generate data in the expected format for a WebGL Scatter plot.
 *
 * @param entry A unit of Plotly data containing points, color, name, and any extras.
 * @param mirrorPoints Should we mirror the points on the x/y axis?
 * @returns Data suitable for consumption by Plotly.
 */


exports.generateScatterGLData = function (entry, mirrorPoints) {
  if (mirrorPoints === void 0) {
    mirrorPoints = false;
  }

  return __assign({}, exports.generateScatterData(entry, mirrorPoints), {
    type: data_1.PLOTLY_CHART_TYPE.scattergl
  });
};
/**
 * Generate data in the expected format for a Scatter plot.
 *
 * @param entry A unit of Plotly data containing points, color, name, and any extras.
 * @param mirrorPoints Should we mirror the points on the x/y axis?
 * @returns Data suitable for consumption by Plotly.
 */


exports.generateScatterData = function (entry, mirrorPoints) {
  if (mirrorPoints === void 0) {
    mirrorPoints = false;
  }

  var marker = entry.marker,
      points = entry.points,
      hoverinfo = entry.hoverinfo,
      subtitle = entry.subtitle,
      name = entry.name,
      text = entry.text;
  var xValues = points.map(function (data) {
    return data.i;
  });
  var yValues = points.map(function (data) {
    return data.j;
  });
  var zValues = points.map(function (data) {
    return data.dist ? data.dist : -1;
  });
  var textValues = text ? Array.isArray(text) ? text : [text] : [];
  return {
    hoverinfo: hoverinfo ? hoverinfo : 'x+y+z',
    marker: __assign({
      color: derivePlotlyColor(mirrorPoints, zValues, entry),
      size: entry.nodeSize
    }, marker),
    mode: 'markers',
    name: name + " " + subtitle,
    text: mirrorPoints ? __spread(textValues, textValues.map( // Given a coordinate '(x, y)', create '(y, x)' - needed because we have custom hover labels.
    function (coord) {
      return "(" + coord.substr(1, coord.length - 2).split(', ').reverse().join(', ') + ")";
    })) : textValues,
    type: data_1.PLOTLY_CHART_TYPE.scatter,
    x: mirrorPoints ? __spread(xValues, yValues) : xValues,
    y: mirrorPoints ? __spread(yValues, xValues) : yValues,
    z: mirrorPoints ? __spread(zValues, zValues) : zValues
  };
};

var derivePlotlyColor = function derivePlotlyColor(mirrorPoints, zValues, entry) {
  var totalColors = mirrorPoints ? zValues.length * 2 : zValues.length;
  var result = new Array(totalColors);

  if (entry.marker && typeof entry.marker.color === 'string') {
    return result.fill(entry.marker.color);
  } else {
    var zStrings = zValues.map(function (val) {
      return val.toString();
    });
    return mirrorPoints ? __spread(zStrings, zStrings) : zStrings;
  }
};

exports.generateFloat32ArrayFromContacts = function (array) {
  var result = new Float32Array(array.length * 2);
  array.forEach(function (item, index) {
    result[index * 2] = item.i;
    result[index * 2 + 1] = item.j;
  });
  return result;
};
/**
 * Generate data in the expected format for a Plotly PointCloud.
 *
 * @param entry A unit of Plotly data containing points, color, and any extras.
 * @param mirrorPoints Should we mirror the points on the x/y axis?
 * @returns Data suitable for consumption by Plotly.
 */


exports.generatePointCloudData = function (entry, mirrorPoints) {
  if (mirrorPoints === void 0) {
    mirrorPoints = false;
  }

  var points = entry.points;
  var coords = exports.generateFloat32ArrayFromContacts(points);
  return {
    marker: __assign({}, entry.marker, {
      sizemax: entry.nodeSize * 2,
      sizemin: entry.nodeSize
    }),
    mode: 'markers',
    type: data_1.PLOTLY_CHART_TYPE.pointcloud,
    xy: mirrorPoints ? new Float32Array(__spread(Array.from(coords), Array.from(coords).slice().reverse())) : coords
  };
};